import { combineReducers } from "@reduxjs/toolkit";
import user from "./slices/user";
import findUser from "./slices/findUserNameApi";
import paymentMethods from "./slices/paymentMethods";
import paymentHistory from "./slices/paymentHistory";
import invoiceHistoryData from "./slices/invoiceHistory";
import nextPaymentDetails from "./slices/nextPaymentDetails";
import serviceDetails from "./slices/serviceDetails";
import invoiceDetails from "./slices/invoiceDetails";
import paymentMethodDetails from "./slices/paymentMethodDetails";
import contentDetails from "./slices/contents/contentDetails";
import upComingAppointment from "./slices/upComingAppointment";
import pastAppointment from "./slices/pastAppointment";
import layoutContentDetails from "./slices/contents/layoutContentDetails";
import planDetails from "./slices/planDetails";
import accountSettingContent from "./slices/contents/accountSettingContent";
import helpSupportContent from "./slices/contents/helpSupportContent";
import loginHeaderContent from "./slices/contents/newloginHeaderContent";
import loginFooterContent from "./slices/contents/newLoginFooterContent";
import homeFooterContent from "./slices/contents/homeFooterContent";
import appointmentContent from "./slices/contents/appointmentContent";
import paymentContent from "./slices/contents/paymentContent";
import homePageContent from "./slices/contents/homePageContent";
import applyAcpModalContent from "./slices/contents/applyAcpModalPageContent";
import brightspeedToken from "./slices/brightspeedToken";
import burriedDrop from "./slices/burriedDrop";
import repairAppointment from "./slices/repairAppointments";
import notificationDetails from "./slices/notificationDetails";
import pastRepairAppointment from "./slices/pastRepairAppointment";
import acpFormContent from "./slices/contents/acpFormPageContent";
import vacationPauseServiceContent from "./slices/contents/vacationPauseServiceContent";
import nonPaySuspendContent from "./slices/contents/nonPaySuspendContent";
import changePlanContent from "./slices/contents/changePlanContent";
import addressQualification from "./slices/addressQualification";
// import quickBillPaymentContent from "./slices/qbpContent";
import amsToken from "./slices/amsToken";
import loginForgetPageContent from "./slices/contents/loginForgetPageContent";
import signUpResetPageContent from "./slices/contents/signUpResetPageContent";
import networkSetting from "./slices/networkSetting";
import networkSettings from "./slices/contents/networkSettingsContent";
import nonAuthPaymentArrangement from "./slices/non-auth-paymentArrangement";
import AccountDetailsByBANNZIP from "./slices/getaccountinfobyban";
import getaddAccountContent from "./slices/contents/addAccountContent";
import quickBillPayContent from "./slices/contents/qbpContentAem";
import notEligibleQBPPaymentContent from "./slices/contents/notEligibleQBPAem";
import EligibleQBPPaymentContent from "./slices/contents/eligibleQBPAem";
import nutritionLabelContent from "./slices/contents/nutritionLabelContent";
import paymentHistoryForPA from './slices/paymentHistoryForPA';
import getV2InternetProductData from "./slices/shopExpProducts";
import getAccordionStateSlice  from "./slices/shopaccordion";
import shopExpProducts from "./slices/shopExpProducts";
import getProductCategoriesSlice from "./slices/shopExpProducts"
import fetchOrderDetailsv2  from "./slices/shopExpProducts"
import getChangeOrderStateSlice from "./slices/shopRevieworder"
// import address from "./slices/shopExpProducts";
import isMigrated from './slices/migrationCheck';
import isSuspendNonPay  from "./slices/suspendNonPayCheck";
import isVacationPause  from "./slices/vacationPauseCheck";
import isOutageCheck  from "./slices/outageCheck";
import cartSlice from "./slices/cartupdationAPI"
import InternetProductsState from "./slices/InternetProductsState";
import brightSpeedUserUtils from "./slices/brightSpeedUserUtils";
import changeFlowContent from './slices/contents/changeFlowContent'
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage
import communityPreferenceToggle from './slices/saveChangesModal';
import commPreference from "./slices/commPreferences";
import communicationPreferenceContent from './slices/contents/communicationPreferenceContent';
import bannerNotification from "./slices/contents/bannerNotificationContent"
import ThicBundleContent from "./slices/contents/thicBundleContent";
import WifiExtenderContent from "./slices/contents/WifiExtenderContent";
import WholeHomeWifiContent from "./slices/contents/WholeHomeWifiContent";
import mySlice from "./slices/notifications";
import dwLogsReducer from './slices/dwLogTracker';
import outageInformation  from "./slices/outageInformation";
import postpaidFiberContent from "./slices/contents/postpaidFiberContent"
import dslmigratorNewContent from './slices/contents/dslmigratornewcontent';
import moversContent from './slices/contents/moversContent';
import myRewardsContent from './slices/contents/myRewardsContent';
import myRewards from "./slices/myRewards";
import trackersContent from './slices/contents/trackersContent';
import appointmentTimeslotData from './slices/dslAppointmentTime';
import userAccountSlice from "./slices/non-auth-getaccountbyfilter";
import confirmAvailableSlotData from "./slices/confirmAvailableSlot";
import setSelectedAppointmentTimeslotData from "./slices/shopExpProducts";
import setDslMigrationPendingApiStatus from "./slices/brightSpeedUserUtils";
import getMoversAppointmentTimeslots  from "./slices/moversAppointmentScheduler";
import moversInternetProductData from './slices/moversInternetProducts';
import moversVoiceProductData from './slices/moversVoiceProducts';
import moversAddonProductData from './slices/moversAddonProducts';
import purlPayment from './slices/moversPurlCall';
import supplementOrder from "./slices/supplementOrder";
import moversCartSlice from "./slices/moversCartUpdateAPI";
import purlPaymentSlice from "./slices/moversPurlCall";
import getCreditMemoSlice from "./slices/getCreditMemo";
import autopayNotifySlice from "./slices/autopayNotify";

const getAccordionStatePersistConfig = {
  key: "getAccordionState",
  storage,
  version: 1, // bump this when structure changes
  blacklist: ['temporaryFlag'], // UI-only fields not needed
  // redux-persist requires migrate to return a Promise<state>. Returning a
  // plain value (or undefined for first-time visitors with no stored state)
  // causes "Cannot read properties of undefined (reading 'then')" during
  // rehydration.
  migrate: (state: any) => {
    // Example migration logic
    if (state && state.version === 0) {
      return Promise.resolve({
        ...state,
        newField: false, // add default for new field
      });
    }
    return Promise.resolve(state);
  }
};

const nutritionLabelContentPersistConfig = {
  key: "nutritionLabelContent", 
  storage, 
};

const CartSliceConfig = {
  key: "cartSliceState",
  storage,
}

const repairAppointmentSliceConfig = {
  key: "repairAppointment",
  storage,
}

const notificationDetailsConfig = {
  key: "notificationDetails",
  storage,
}

const findusernameConfig = {
  key: "findUser",
  storage,
}

const nonAuthuserAccountSliceConfig = {
  key: "userAccountSlice",
  storage,
}
const getProductCategoriesSliceConfig = {
  key: "getAppointmentSlotsData",
  storage,
}
const setDslMigrationPendingApiStatusConfig = {
  key: "setDslMigrationPendingApiStatus",
  storage,
}
const brightspeedTokenConfig= {
  key: "brightspeedToken",
  storage,
}
const getProductCategoriesConfig = {
  key: "getProductState", 
  storage, 
};

const getPreInstallServices = {
  key: "preInsttallService", 
  storage, 
};

const addressQualificationConfig = {
  key: "addressQualification",
  storage,
};

const moversAppointmentConfig = {
  key: "getMoversAppointmentTimeslots",
  storage,
};

const moversCartSliceConfig = {
  key: "moversCartSliceState",
  storage,
};

const purlPaymentConfig = {
  key: "purlPayment",
  storage,
};

const moversInternetProductConfig = {
  key: "moversInternetProductData",
  storage,
};

const moversVoiceProductConfig = {
  key: "moversVoiceProductData",
  storage,
};

const moversAddonProductConfig = {
  key: "moversAddonProductData",
  storage,
};

const rootReducer = combineReducers({
  loginHeaderContent,
  loginFooterContent,
  homeFooterContent,
  user,
  paymentMethods,
  paymentHistory,
  invoiceHistoryData,
  nextPaymentDetails,
  serviceDetails,
  invoiceDetails,
  paymentMethodDetails,
  contentDetails,
  upComingAppointment,
  pastAppointment,
  layoutContentDetails,
  planDetails,
  accountSettingContent,
  helpSupportContent,
  appointmentContent,
  paymentContent,
  homePageContent,
  brightspeedToken:persistReducer(brightspeedTokenConfig, brightspeedToken),
  burriedDrop,
  repairAppointment:persistReducer(repairAppointmentSliceConfig, repairAppointment),
  notificationDetails:persistReducer(notificationDetailsConfig, notificationDetails),
  pastRepairAppointment,
  applyAcpModalContent,
  acpFormContent,
  vacationPauseServiceContent,
  nonPaySuspendContent,
  changePlanContent,
  addressQualification: persistReducer(addressQualificationConfig, addressQualification),
  amsToken,
  loginForgetPageContent,
  signUpResetPageContent,
  // quickBillPaymentContent,
  networkSetting,
  networkSettings,
  nonAuthPaymentArrangement,
  AccountDetailsByBANNZIP,
  getaddAccountContent,
  quickBillPayContent,
  notEligibleQBPPaymentContent,
  EligibleQBPPaymentContent,
  nutritionLabelContent: persistReducer(nutritionLabelContentPersistConfig, nutritionLabelContent), 
  paymentHistoryForPA,
  getV2InternetProductData,
  getAccordionStateSlice: persistReducer(getAccordionStatePersistConfig, getAccordionStateSlice), 
  shopExpProducts,
  getProductCategoriesSlice : persistReducer(getProductCategoriesConfig, getProductCategoriesSlice),
  fetchOrderDetailsv2,
  getChangeOrderStateSlice,
  isMigrated,
  isOutageCheck,
  isSuspendNonPay,
  isVacationPause,
  cartSlice: persistReducer(CartSliceConfig, cartSlice),
  InternetProductsState,
  brightSpeedUserUtils,
  changeFlowContent,
  communityPreferenceToggle,
  commPreference,
  communicationPreferenceContent,
  bannerNotification,
  ThicBundleContent,
  WifiExtenderContent,
  WholeHomeWifiContent,
  mySlice,
  findUser:persistReducer(findusernameConfig, findUser),
  dwLogsReducer,
  outageInformation,
  postpaidFiberContent,
  dslmigratorNewContent,
  moversContent,
  myRewardsContent,
  myRewards,
  trackersContent,
  appointmentTimeslotData,
  userAccountSlice:persistReducer(nonAuthuserAccountSliceConfig, userAccountSlice),
  setSelectedAppointmentTimeslotData: persistReducer(getProductCategoriesSliceConfig, setSelectedAppointmentTimeslotData),
  setDslMigrationPendingApiStatus: persistReducer(setDslMigrationPendingApiStatusConfig, setDslMigrationPendingApiStatus),
  confirmAvailableSlotData,
  getMoversAppointmentTimeslots: persistReducer(moversAppointmentConfig, getMoversAppointmentTimeslots),
  moversInternetProductData: persistReducer(moversInternetProductConfig, moversInternetProductData),
  moversVoiceProductData: persistReducer(moversVoiceProductConfig, moversVoiceProductData),
  moversAddonProductData: persistReducer(moversAddonProductConfig, moversAddonProductData),
  purlPayment: persistReducer(purlPaymentConfig, purlPayment),
  supplementOrder: persistReducer(getPreInstallServices,supplementOrder),
  moversCartSlice: persistReducer(moversCartSliceConfig, moversCartSlice),
  getCreditMemoSlice,
  autopayNotifySlice,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;